import AEMWrapper from "aem/ComponentWrapper";
import meta from "./aem-meta";
import Component from "./aem-component";
import ContainerWrapper from "concierge-alias-aem/ContainerWrapper";

export default AEMWrapper(meta, Component, { wrapper: ContainerWrapper });
